<template>
  <div class="InputLanguages">

    <div class="loading-holder" v-if="!languages">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="input-languages-card mdl-card mdl-shadow--2dp" v-if="languages" v-bind:class="{ blurred: state == 'working' }">

      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Input Languages</h2>
      </div>

      <!--  <div class="mdl-card__supporting-text search">
          <i class="material-icons searchIcon">search</i>
          <div class="mdl-textfield mdl-js-textfield">
            <input class="mdl-textfield__input" type="text" id="search" v-model="search">
            <label class="mdl-textfield__label" for="search">Search...</label>
          </div>
        </div>-->

      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="languages-list list" v-if="!deleting">
          <div v-for="file in languages" class="file">
            <!--{{ JSON.stringify(file) }}-->
            <router-link :to="{ name: 'inputLanguage', params: { name: file.name } }">
              <span class="name" v-if="renaming != file">{{ file.name }}</span>
            </router-link>
            <span class="buttons" v-if="!renaming && !deleting">
              <span class="btn" v-on:click="remove(file)"><i class="material-icons">delete_forever</i></span>
              <span class="btn" v-on:click="rename(file)"><i class="material-icons">create</i></span>
            </span>

            <span class="rename" v-if="renaming == file">
              <input type="text" v-model="newName">
            </span>
            <span class="buttons" v-if="renaming == file">
              <span class="btn" v-on:click="finishRename"><i class="material-icons">done</i></span>
            </span>
           <!-- <router-link :to="{ name: 'log', params: { logId: log.logId } }">
              <span>{{ formatTime(log.date) }}</span>:
              <span>{{ log.ip }}</span>
            </router-link>-->
          </div>

        </div>

        <div v-if="deleting" class="deleteDialog">
          <p>
            Do you really want to delete language {{ deleting.name }}
          </p>
          <div class="yesno">
            <span @click="confirmDelete"
              class="btn mdl-button mdl-js-button mdl-button--raised mdl-button--accent">Yes</span>
            <span @lick="cancelDelete"
                  class="btn mdl-button mdl-js-button mdl-button--raised mdl-button--colored">No</span>
          </div>
        </div>

      </div>

      <div class="mdl-card__supporting-text mdl-card--border" v-if="!deleting">
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
          <input class="mdl-textfield__input" type="text" id="fileName" v-model="newLanguageCode"
                 v-bind:required="required" ref="fileName">
          <label class="mdl-textfield__label" for="fileName">Language code</label>
        </div>
        <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" @click="addLanguage">
          <i class="material-icons">add</i>
          Add Language
        </button>
      </div>
    </div>

  </div>
</template>

<script>

  import api from "api"

  import languageInitialData from "./initData.js"

  export default {
    name: "InputLanguages",
    reactive: {
      languages: ['config', 'inputLanguagesList']
    },
    data() {
      return {
        state: "ready",
        required: false,
        newLanguageCode: "",

        renaming: null,
        deleting: null,
        newName: ""
      }
    },
    methods: {
      addLanguage() {
        if(this.newLanguageCode.trim()=='') {

          this.required = true
          this.$refs.fileName.parentElement.setAttribute('class',
            this.$refs.fileName.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.fileName.focus()

          return
        }

        for(let lang of this.languages) {
          if(lang.name == this.newLanguageCode) {
            this.required = true
            this.$refs.fileName.parentElement.setAttribute('class',
              this.$refs.fileName.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.fileName.focus()
            return;
          }
        }

        this.state = "working"
        api.request(['config', 'saveInputLanguage'], this.newLanguageCode, languageInitialData).then(
          result => this.state = "done"
        ).catch(
          error => {
            this.error = error
            this.state = "error"
          }
        )

      },
      remove(file) {
        this.deleting = file
      },
      rename(file) {
        this.newName = file.name
        this.renaming = file
      },
      finishRename() {
        this.state = "working"
        api.request(['config','renameInputLanguage'], this.renaming.name, this.newName).then(
          done => {
            this.renaming.name = this.newName
            this.renaming = null
            this.state = "ready"
          }
        )
      },
      confirmDelete() {
        this.state = "working"
        api.request(['config','removeInputLanguage'], this.deleting.name).then(
          done => {
            this.deleting = null
            this.state = "ready"
          }
        )
      },
      cancelDelete() {
        this.deleting = null
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<style scoped>

  .input-languages-card {
    margin: 23px auto auto;
    min-height: 70vh;
    min-width: 91%;
  }

  .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }
  .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }

  .list {

  }

  .file {
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    max-width: 200px;
    height: 2em;
    padding: 3px;
    line-height: 2em;
    cursor: pointer;
    font-weight: 300;
  }
  .file i {
    display: inline-block;
    vertical-align: middle;
  }
  .file .name {
    font-size: 1.23em;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file:hover {
    color: black;
  }
  .file:hover .name {
    text-decoration: underline;
  }

  .file.selected {
    background: #00bcd4;
    color: #000000;
  }
  .file.selected:hover {
    background: #00c1d8;
    color: #000000;
  }

  .file .buttons {
    float: right;
  }
  .file .buttons .btn {
    display: inline-block;
    border: none;
    border-radius: 200px;
    background: white;
    width: 28px;
    height: 28px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
  }
  .rename {
    position: relative;
    display: block;
    position: absolute;
    left: 32px;
    right: 32px;
    width: auto;
    height: 100%;
    top: 0;
  }
  .file input {
    border: 0;
    background: none;
    font-size: 1.23em;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .deleteDialog {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .deleteDialog p {
    font-size: 1.23em;
  }

  .blurred {
    filter: blur(2px);
  }

</style>



// WEBPACK FOOTER //
// InputLanguages.vue?632553e6